export default __webpack_public_path__ + "static/media/gt.22868e05.svg";